import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { FEATURE_GATES } from '@healthdesk/shared-utils';

/**
 * Returns access status for a feature key from the FEATURE_GATES config.
 * @param {string} featureKey — key from FEATURE_GATES (e.g. 'symptom-voice')
 * @returns {{ hasAccess: boolean, requiredTier: string|null }}
 */
export function useFeatureAccess(featureKey) {
  const { hasTierAccess } = useAuth();

  return useMemo(() => {
    const gate = FEATURE_GATES[featureKey];
    if (!gate) return { hasAccess: true, requiredTier: null };
    return {
      hasAccess: hasTierAccess(gate.minTier),
      requiredTier: gate.minTier,
    };
  }, [featureKey, hasTierAccess]);
}
